import { Container, Nav, Navbar, Offcanvas } from "react-bootstrap";
import styled, { css } from "styled-components";
import { COLOR_WHITE } from "../constants/colors";
import bgGray from "../images/bg-gray.png";
import SocialMedias from "./SocialMedias";
import { Heading4, Heading6 } from "./Typography";

const StyledHeader = styled.header<{ variant: string }>`
  ${(props) =>
    props.variant === "floating" &&
    css`
      padding-bottom: 66px;

      @media (max-width: 768px) {
        padding-bottom: 33px;
      }
    `}
  ${(props) =>
    props.variant === "default" &&
    css`
      background-image: url(${bgGray});
      background-repeat: no-repeat;
      background-position-x: center;
      background-position-y: 0;
      background-size: cover;
    `}
`;

const Title = styled.a`
  ${Heading6}
  color: ${COLOR_WHITE};
  padding: 10px;
  padding-right: 20px;

  &:hover {
    text-decoration: none;
    color: ${COLOR_WHITE};
  }
`;

const NavTitle = styled(Title)`
  ${Heading4}
`;

function Header({ variant }: { variant?: string }) {
  return (
    <StyledHeader variant={variant || "floating"}>
      <Navbar bg="none" expand="lg" variant="dark">
        <Container>
          <Navbar.Toggle />
          <Navbar.Offcanvas placement="start">
            <Offcanvas.Header className="pb-0" closeVariant="white" closeButton>
              <Offcanvas.Title>
                <NavTitle>Menus</NavTitle>
              </Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body className="pt-1">
              <Nav className="justify-content-start">
                <Title href="https://beartiger.io">Home</Title>
                <Title href="https://merch.beartiger.io/">Shop</Title>
           
                <Title href="https://goat.beartiger.io/"target="_blank">Goat Gallery</Title>
             
              </Nav>
            </Offcanvas.Body>
          </Navbar.Offcanvas>
          <Navbar.Brand className="me-0">
            <SocialMedias />
          </Navbar.Brand>
        </Container>
      </Navbar>
    </StyledHeader>
  );
}

export default Header;

Header.defaultProps = {
  variant: "floating",
};
